<template>
  <div class="base-check-box">
    <label>
      <BaseIcon :name="iconName"></BaseIcon>
      <input type="checkbox" :name="name" :value="optionValue" :checked="checked" v-on="listeners"/>
      <p><slot></slot></p>
    </label>
  </div>
</template>

<script>
  import { omit } from 'lodash'

  const CUSTOM_EVENTS = {
    input: 'input'
  }

  export default {
    props: {
      optionValue: {
        type: String,
        required: true
      },
      value: Array,
      name: {
        type: String,
        required: true
      }
    },
    computed: {
      checked () {
        return this.value.includes(this.optionValue)
      },
      listeners () {
        const filteredListeners = omit(this.$listeners, Object.values(CUSTOM_EVENTS))

        return {
          ...filteredListeners,
          change: e => {
            let value = [...this.value]
            if(this.checked){
              value.splice(value.indexOf(this.optionValue), 1)
            } else {
              value.push(this.optionValue)
            }

            this.$emit(CUSTOM_EVENTS.input, value)
          }
        }
      },
      iconName () {
        return this.checked ? 'checkbox-selected' : 'checkbox-unselected'
      }
    }
  }
</script>

<style lang="scss">
  .base-check-box {

    label {
      display: inline-flex;
      align-items: center;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
        margin-right: 9px;
      }

      p {
        font-size: 14.6px;
        line-height: 28px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseCheckBox.vue